import { isCommercial, offerTypeFromJsonQuery } from '../../../../JsonQuery';
import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const floornTagManager = createRangeTagManager({
  jsonQueryKey: 'floorn',
  template: 'Этажей в здании %s',
  id: 'floorn',
  isApplicable: jsonQuery => isCommercial(offerTypeFromJsonQuery(jsonQuery)),
});
